<template>
  <div id="app">
    <keep-alive>
      <router-view :key="$route.path" />
    </keep-alive>
  </div>
</template>

<script>
import isMobile from './utils/isMobile'
export default {
  name: 'App',
  created() {
    // 创建一个新的meta标签元素
    // var metaTag = document.createElement('meta')

    // // 设置meta标签的属性和值
    // metaTag.setAttribute('name', 'facebook-domain-verification') // 例如，设置name属性为viewport
    // metaTag.setAttribute('content', process.env.FB_CONTENT) // 设置content属性

    // // 将新的meta标签添加到head标签内
    // console.log(metaTag)
    // document.head.appendChild(metaTag)

    if (isMobile()) {
      var body = document.documentElement
      const styles = `::-webkit-scrollbar {width: 0px;}`
      const style = document.createElement('style')
      style.textContent = styles
      document.head.appendChild(style)
    }
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue